import React, {Fragment, useEffect, useRef, useState} from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './index.scss';
import url from '../../../../api/base-url';
import DataGrid, {Column, MasterDetail, Lookup, Button as GridButton,Selection,Editing} from 'devextreme-react/data-grid';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import {createStore} from "devextreme-aspnet-data-nojquery";
import sessions from '../../../../sessions';
import {Button} from 'devextreme-react/button';
import ShipmentDetailsView from '../shipment-view/index';
import ShipmentDetailsEdit from '../shipment-edit/index';
import ShipmentDetails from '../../shipment-details/index';
import GenerateMultipleLabel from '../../../../pages/Orders/multiple-label/multiple-label';
import notify from 'devextreme/ui/notify';
import saveAs from 'file-saver';

const Recent = () => {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [isShipmentDetailsView,setIsShipmentDetailsView] = useState(false);
    const [isShipmentDetailsEdit,setIsShipmentDetailsEdit] = useState(false);
    const [isGenerateMultipleLabel, setIsGenerateMultipleLabel] = useState(false);
    const [activateButtonActions,setActivateButtonActions] = useState(false);
    const [selectedRows,setSelectedRows] = useState();
    var dataGrid = null;

    const shipmentDetailEditRef = useRef();
    const gmlRef = useRef();
    const GridRef = useRef();

    useEffect(() => {

        dataGrid = GridRef.current.instance;
    });

    function getConfig(options) {
        options.onBeforeSend = function (method, ajaxOptions) {
            ajaxOptions.headers = {
                "x-access-token": auth
            }
        }
        return options;
    };
   
    const recentShipmentDataSource = createStore(getConfig({
        key: '_id',
        loadUrl: `${url}/admin/shipments/recents`
    }));

    const DetailEditCancelButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsShipmentDetailsEdit(false)
    }

    const DetailEditSaveButton = {
        text: 'update',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => shipmentDetailEditRef
            .current
            .saveOnClick(e)
    }

    const DetailViewCancelButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsShipmentDetailsView(false)
    }

    const saveGmlButton = {
        text: 'Print Multiple Labels',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => gmlRef
        .current
        .saveOnClick(e)
    };

    const cancelGmlButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsGenerateMultipleLabel(false)
    };
    
    const downloadLabel = (data) => {
        //console.log("albel",data);
        var urlLink = data.labelUrl;
        var labelName = `${data.shipmentNo}.pdf`
        if(urlLink)
            saveAs(urlLink,labelName);
        else
            notify("there is no generated label or the link expired");
    };

    const gmlOnClick = () =>{
        dataGrid.getSelectedRowsData().then(selectedRows=>{
            setSelectedRows(selectedRows);
            setIsGenerateMultipleLabel(true);
        });
    }

    const onSelectionChanged = (e) => {
        dataGrid.getSelectedRowsData().then(selectedRows=>{
            console.log(selectedRows);
            selectedRows.map(item=>{
                if(item.batchNo){
                    setActivateButtonActions(true)
                }else{
                    setActivateButtonActions(false)
                }
            })
        })
    }

    return (
        <Fragment>
            <Popup
                id="ShipmentDetailsEditPopUp"
                title={'Shipment Details'}
                visible={isShipmentDetailsEdit}
                onHiding={e => {setIsShipmentDetailsEdit(false)}}
            >
                <ShipmentDetailsEdit ref={shipmentDetailEditRef} data={selectedRows}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailEditSaveButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailEditCancelButton}></ToolbarItem>
            </Popup>
            <Popup
                id="ShipmentDetailsViewPopUp"
                title={'Shipment Details'}
                visible={isShipmentDetailsView}
                onHiding={e => setIsShipmentDetailsView(false)}>
                <ShipmentDetailsView data={selectedRows}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailViewCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="generate-multiple-label"
                 visible={isGenerateMultipleLabel}
                 onHiding={e => {setIsGenerateMultipleLabel(false)}}
                 showTitle={true}
                 title= "Batch Shipments"
                 width={'50vw'}
                 >
                     <ScrollView>
                        <GenerateMultipleLabel ref={gmlRef} data = {selectedRows}/>
                     </ScrollView>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={saveGmlButton}></ToolbarItem>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={cancelGmlButton}></ToolbarItem>
            </Popup>
            <h4 className={'content-block'}>Recents</h4>
            <div className={'content-block'}>
                <Button
                        className="m-2"
                        icon='exportpdf'
                        text="Print Multiple Labels"
                        disabled={!activateButtonActions}
                        onClick = {gmlOnClick}/>
                <br/>
                <DataGrid
                    id={'admin-recent'}
                    ref={GridRef}
                    dataSource={recentShipmentDataSource}
                    showBorders={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    columnResizingMode={'nextColumn'}
                    onSelectionChanged={onSelectionChanged}
                    >
                    <Column dataField={'orderNo'}/>
                    <Column dataField={'shipmentNo'}/>
                    <Column dataField={'batchNo'}/>
                    <Column dataField={'serviceType'}/>
                    <Column dataField={'tracking_number'} caption={'Tracking No'}/>
                    <Column dataField={'shipDate'} dataType={"date"}/>
                    <Column
                        dataField={'actionButton'}
                        type="buttons"
                        width={110}
                        type="buttons"
                        buttons={[
                        {
                            icon: 'fa fa-eye',
                            hint: 'view shipment',
                            onClick: (e) => {
                                setIsShipmentDetailsView(true);
                                setSelectedRows(e?.row?.data)
                            }
                        }
                    ]}/>
                     <Selection mode="multiple" allowSelectAll={true} deferred={true} selectAllMode={'Pages'}/>
                    <MasterDetail enabled={true} component={ShipmentDetails}/>
                </DataGrid>
            </div>
        </Fragment>
    )
};
export default Recent;